import _regenerator from "C:/Users/lptni/\u5F00\u53D1/dev/project/unbox-server/vue-admin/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "C:/Users/lptni/\u5F00\u53D1/dev/project/unbox-server/vue-admin/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import api from '@/api';
export default {
  name: 'financeMatchmakerMonthlySettlementList',
  data: function data() {
    return {
      apiUrl: process.env.VUE_APP_API,
      isSelect: this.checkauthority('finance_Monthly_Settlement_select'),
      isExport: this.checkauthority('finance_Monthly_Settlement_export'),
      selectForm: {
        mSettlementId: null,
        agencyId: null,
        settlementTime: null,
        settlementAccount: null,
        deductionsAccount: null,
        actualSettlement: null,
        createTime: null,
        settlementTimes: [],
        settlementSts: null
      },
      editDisabled: false,
      dialogVisible: false,
      pageNo: 1,
      pageSize: 10,
      tableSelects: [],
      tableData: [],
      pageTotal: 0,
      centerDialogVisible: false,
      sumAccount: 0,
      updateMatchmakerDialogVisible: false,
      updateMatchmakerForm: {
        mSettlementId: null,
        userName: ''
      },
      updateMatchmakerRules: {
        userName: [{
          required: true,
          message: '红娘账号不能为空',
          trigger: 'blur'
        }]
      }
    };
  },
  methods: {
    /**
     * 单个结算。
     */
    settlement: function settlement(row) {
      var _this = this;
      this.$confirm('确定要进行结算操作吗, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this.settlementApi(row.msettlementId);
      }).catch(function () {
        _this.$message({
          type: 'info',
          message: '已取消'
        });
      });
    },
    /**
     * 结算Api
     * @param settlementId
     * @returns {Promise<void>}
     */
    settlementApi: function settlementApi(mSettlementId) {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var par;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              par = {};
              if (mSettlementId !== null) {
                par.msettlementId = mSettlementId;
                par.settlementSts = 1;
              }
              _context.n = 1;
              return api.byMatchmakerMonthlySettlementUpdate(par);
            case 1:
              _this2.$message.success('操作成功');
              _context.n = 2;
              return _this2.initTableData();
            case 2:
              return _context.a(2);
          }
        }, _callee);
      }))();
    },
    exportExcel: function exportExcel() {
      var par = {
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        settlementTime: this.selectForm.settlementTime,
        settlementSts: 0
      };
      if (this.selectForm.settlementTimes.length >= 2) {
        par.startSettlementTime = this.selectForm.settlementTimes[0];
        par.endSettlementTime = this.selectForm.settlementTimes[1];
      }
      var apiUrl = 'admin/v1/byMatchmakerMonthlySettlement/financeExport';
      this.downloadUtil.excelExport(apiUrl, par, '红娘待结算明细表.xls');
    },
    initEunmData: function initEunmData() {
      this.getEnumList('key');
    },
    getEnumList: function getEnumList(name) {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var par, res;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              par = {
                name: name
              };
              _context2.n = 1;
              return api.GET_ENUMERATION_LIST(par);
            case 1:
              res = _context2.v;
              _this3.enumList = res.body;
            case 2:
              return _context2.a(2);
          }
        }, _callee2);
      }))();
    },
    dalete: function dalete(index, data) {
      var _this4 = this;
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this4.daleteApi(index, data);
      }).catch(function () {
        _this4.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    daleteApi: function daleteApi(index, data) {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var par;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              par = {
                mSettlementId: data.mSettlementId
              };
              _context3.n = 1;
              return api.DELETE_AGENCYMONTHLYSETTLEMENT(par);
            case 1:
              _this5.initTableData();
            case 2:
              return _context3.a(2);
          }
        }, _callee3);
      }))();
    },
    deleteBatchApi: function deleteBatchApi(par) {
      var _this6 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              _context4.n = 1;
              return api.DELETE_BATCH_AGENCYMONTHLYSETTLEMENT(par);
            case 1:
              _this6.$message.success('操作成功');
              _this6.initTableData();
            case 2:
              return _context4.a(2);
          }
        }, _callee4);
      }))();
    },
    getUnsettledTotalAccount: function getUnsettledTotalAccount() {
      var _this7 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        var res;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              _context5.n = 1;
              return api.getUnsettledTotalAccount();
            case 1:
              res = _context5.v;
              _this7.sumAccount = res.body;
            case 2:
              return _context5.a(2);
          }
        }, _callee5);
      }))();
    },
    deleteBatch: function deleteBatch() {
      var _this8 = this;
      if (this.tableSelects.length === 0) {
        this.$message.error('请勾选要删除的表格数据');
        return;
      }
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        var par = [];
        _this8.tableSelects.forEach(function (element) {
          par.push(element.mSettlementId);
        });
        _this8.deleteBatchApi(par);
      }).catch(function () {
        _this8.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    info: function info(index, data) {
      this.editDisabled = true;
      this.dialogVisible = true;
      this.$refs.edit.setTitle('详情');
      this.$refs.edit.setData(data);
    },
    edit: function edit(index, data) {
      this.dialogVisible = true;
      this.editDisabled = false;
      this.$refs.edit.setTitle('编辑');
      this.$refs.edit.setData(data);
    },
    toAdd: function toAdd() {
      this.$refs.edit.setTitle('新增');
      this.editDisabled = false;
      this.dialogVisible = true;
      this.$refs.edit.initData();
    },
    userEditClose: function userEditClose() {
      this.dialogVisible = false;
    },
    reset: function reset() {
      this.pageNo = 1;
      this.selectForm.mSettlementId = null;
      this.selectForm.agencyId = null;
      this.selectForm.settlementTime = null;
      this.selectForm.settlementAccount = null;
      this.selectForm.deductionsAccount = null;
      this.selectForm.actualSettlement = null;
      this.selectForm.createTime = null;
      this.selectForm.settlementTimes = [];
      this.selectForm.settlementSts = null;
      this.initTableData();
    },
    search: function search() {
      this.pageNo = 1;
      this.initTableData();
    },
    initTableData: function initTableData() {
      var _this9 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6() {
        var par, res;
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.n) {
            case 0:
              par = {
                pageNo: _this9.pageNo,
                pageSize: _this9.pageSize,
                settlementTime: _this9.selectForm.settlementTime,
                settlementSts: 0
              };
              if (_this9.selectForm.settlementTimes.length >= 2) {
                par.startSettlementTime = _this9.selectForm.settlementTimes[0];
                par.endSettlementTime = _this9.selectForm.settlementTimes[1];
              }
              _context6.n = 1;
              return api.GET_MATCHMAKERMONTHLYSETTLEMENT_PAGE_LIST(par);
            case 1:
              res = _context6.v;
              _this9.tableData = res.body.datas;
              _this9.pageTotal = res.body.sumDataCount;
              _this9.getUnsettledTotalAccount();
            case 2:
              return _context6.a(2);
          }
        }, _callee6);
      }))();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.pageSize = val;
      this.initTableData();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.pageNo = val;
      this.initTableData();
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.tableSelects = val;
    },
    openUpdateMatchmakerDialog: function openUpdateMatchmakerDialog(row) {
      this.updateMatchmakerForm.mSettlementId = row.msettlementId;
      this.updateMatchmakerForm.userName = '';
      this.updateMatchmakerDialogVisible = true;
    },
    updateSettlementMatchmaker: function updateSettlementMatchmaker() {
      var _this0 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8() {
        return _regenerator().w(function (_context8) {
          while (1) switch (_context8.n) {
            case 0:
              _this0.$refs.updateMatchmakerForm.validate(/*#__PURE__*/function () {
                var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7(valid) {
                  var _t;
                  return _regenerator().w(function (_context7) {
                    while (1) switch (_context7.p = _context7.n) {
                      case 0:
                        if (!valid) {
                          _context7.n = 5;
                          break;
                        }
                        _context7.p = 1;
                        _context7.n = 2;
                        return api.updateSettlementMatchmaker({
                          mSettlementId: _this0.updateMatchmakerForm.mSettlementId,
                          userName: _this0.updateMatchmakerForm.userName
                        });
                      case 2:
                        _this0.$message.success('修改成功');
                        _this0.updateMatchmakerDialogVisible = false;
                        _this0.initTableData();
                        _context7.n = 4;
                        break;
                      case 3:
                        _context7.p = 3;
                        _t = _context7.v;
                        _this0.$message.error(_t.message || '操作失败');
                      case 4:
                        _context7.n = 6;
                        break;
                      case 5:
                        return _context7.a(2, false);
                      case 6:
                        return _context7.a(2);
                    }
                  }, _callee7, null, [[1, 3]]);
                }));
                return function (_x) {
                  return _ref.apply(this, arguments);
                };
              }());
            case 1:
              return _context8.a(2);
          }
        }, _callee8);
      }))();
    }
  },
  created: function created() {
    if (this.isSelect) {
      return;
    }
    this.initTableData();
  }
};